// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"128":"118da550","133":"98d63ada","135":"27f15d13","144":"28e31634","162":"f9db24b4","296":"6936ae05","311":"a0cfc773","329":"c70d0391","423":"44ddc760","488":"193dfc94","648":"3242d8f2","671":"b760ad45","740":"539e67ef","759":"74435930"}[chunkId] + ".chunk.js";
};